// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__uJzMs","header":"Section_header__Xm4js","container":"Section_container__Bv2Mk","dark":"Section_dark__Jhzgy"};